<template>
<div class="mod-config">
    <el-form :inline="true" :model="dataForm">
        <el-form-item label="" prop="courseCode">
            <el-input v-model="dataForm.courseCode" placeholder="课程编码" clearable></el-input>
        </el-form-item>
        <el-form-item label="" prop="courseName">
            <el-input v-model="dataForm.courseName" placeholder="课程名称" clearable></el-input>
        </el-form-item>
        <el-form-item label="" prop="itemId">
            <el-dict-select placeholder="所属系列" v-model="dataForm.itemId" type="courseItemSelects" :props="{ value: 'id', label: 'itemName' }"></el-dict-select>
        </el-form-item>
        <el-form-item label="" rop="stageId">
            <el-dict-select placeholder="所属阶段" v-model="dataForm.stageId" :params="stageDictParams" type="courseStageSelects" :props="{ value: 'id', label: 'stageName' }"></el-dict-select>
        </el-form-item>
        <el-form-item label="" v-if="manageOrgIdFlag()">
            <el-dict-select placeholder="状态" v-model="dataForm.onlineStatus" type="listByType" :props="{ label: 'value', value: 'code' }" :params="onlineStatusParams"></el-dict-select>
        </el-form-item>
        <el-form-item>
            <el-button @click="rgetDataList()">查询</el-button>
            <el-button v-if="isAuth('course:course:save')" type="primary" @click="addOrUpdateHandle()">新增</el-button>
            <el-button type="info" @click="excel" v-if="isAuth('sys:course:export')">导出<i class="el-icon-download"></i></el-button>
        </el-form-item>
    </el-form>
    <el-table :data="dataList" border v-loading="dataListLoading" style="width: 100%">
        <el-table-column type="index" header-align="center" align="center" label="序号" :index="indexMethod" width="50">
        </el-table-column>
        <el-table-column prop="courseCode" header-align="center" align="center" label="课程编码" v-if="manageOrgIdFlag()">
        </el-table-column>
        <el-table-column prop="courseName" header-align="center" align="center" label="课程名称">
        </el-table-column>
        <el-table-column prop="itemName" header-align="center" align="center" label="所属系列">
        </el-table-column>
        <el-table-column prop="stageName" header-align="center" align="center" label="所属阶段">
        </el-table-column>
        <!--    <el-table-column
        prop="orgName"
        header-align="center"
        align="center"
        label="所属机构"
      >
      </el-table-column>-->

        <el-table-column prop="createName" header-align="center" align="center" v-if="manageOrgIdFlag()" label="创建人">
        </el-table-column>

        <el-table-column prop="updateName" header-align="center" align="center" v-if="manageOrgIdFlag()" label="修改人">
        </el-table-column>

        <el-table-column prop="createTime" header-align="center" align="center" v-if="manageOrgIdFlag()" label="创建时间">
        </el-table-column>

        <el-table-column prop="updateTime" header-align="center" align="center" v-if="manageOrgIdFlag()" label="修改时间">
        </el-table-column>

        <el-table-column prop="courseNum" header-align="center" align="center" v-if="!manageOrgIdFlag()" label="所扣课时">
        </el-table-column>

        <el-table-column prop="statusName" header-align="center" align="center" v-if="!manageOrgIdFlag()" label="课程状态">
        </el-table-column>

        <el-table-column v-if="manageOrgIdFlag()" prop="sort" header-align="center" align="center" label="所扣课时">
            <template #default="{ row }">
                <div v-if="!row.courseNumFlag" @click="onClickCourseNumRow(row)">
                    {{ row.courseNum }}
                </div>
                <div v-else>
                    <el-input v-model="row.courseNum" @blur="onCourseNumBlur(row)"></el-input>
                </div>
            </template>
        </el-table-column>

        <el-table-column v-if="manageOrgIdFlag()" prop="sort" header-align="center" align="center" label="排序">
            <template #default="{ row }">
                <div v-if="!row.sortFlag" @click="onClickRow(row)">
                    {{ row.sort }}
                </div>
                <div v-else>
                    <el-input v-model="row.sort" @blur="onSortBlur(row)"></el-input>
                </div>
            </template>
        </el-table-column>

        <el-table-column v-if="manageOrgIdFlag()" prop="onlineStatus" header-align="center" align="center" label="课程状态">
            <template #default="{ row }">
                <el-switch v-model="row.onlineStatus" @change="changeOnlineStatus(row)" active-color="#13ce66" inactive-color="#ff4949">
                </el-switch>
            </template>
        </el-table-column>

        <el-table-column header-align="center" align="center" width="200" label="操作">
            <template slot-scope="{ row }">
                <el-button v-if="isAuth('sys:course:editKePingModel')" type="text" size="small" @click="editKePingModel(row)">课评模板</el-button>
                <el-button :disabled="row. onlineStatus==0?true:false" v-if="isAuth('course:record:save')" type="text" size="small" @click="paike(row.id)">排课</el-button>
                <el-button v-if="isAuth('course:course:update')" type="text" size="small" @click="addOrUpdateHandle(row.id)">修改</el-button>
                <el-button v-if="isAuth('course:material:update')" type="text" size="small" @click="updateMaterial(row.id)">编辑资料</el-button>
                <el-button v-if="isAuth('course:material:update')" type="text" size="small" @click="updateMaterialExpand(row.id)">资源拓展</el-button>
                <el-button v-if="isAuth('course:course:delete')" type="text" size="small" @click="deleteHandle(row)" style="color:#F56E6E">删除</el-button>
                <!--  -->
            </template>
        </el-table-column>
    </el-table>
    <el-pagination @size-change="sizeChangeHandle" @current-change="currentChangeHandle" :current-page="pageIndex" :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalPage" layout="total, sizes, prev, pager, next, jumper">
    </el-pagination>
    <!-- 物料弹窗 -->
    <course-material v-if="materialVisible" ref="material" @refreshDataList="getDataList"></course-material>
    <!-- 弹窗, 新增 / 修改 -->
    <add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
    <!-- 排课 -->
    <course-pai-ke ref="paike" v-model="drawerVisible" @submit="handleSubmit"></course-pai-ke>
    <!-- 物料拓展 -->
    <courseMaterialExpand @refreshDataList="getDataList" ref="courseMaterialExpand"></courseMaterialExpand>
    <el-drawer title="编辑课评模板" :visible.sync="drawerBycourseEvluation">
        <div class="demo-drawer__content">
            <el-form ref="form4courseevaluation" :rules="rules4courseevaluation" :model="form4courseevaluation" label-width="100px">
                <el-form-item label="知识点" prop="knowledgepoints">
                    <el-input type="textarea" v-model="form4courseevaluation.knowledgepoints" :maxlength="30" placeholder="请输入知识点"></el-input>
                </el-form-item>
                <el-form-item label="教具及材料" prop="stuff">
                    <el-input type="textarea" v-model="form4courseevaluation.stuff" :maxlength="60" placeholder="请输入教具及材料"></el-input>
                </el-form-item>
                <el-form-item label="工具" prop="tools">
                    <el-input type="textarea" v-model="form4courseevaluation.tools" :maxlength="30" placeholder="请输入工具"></el-input>
                </el-form-item>
                <el-form-item label="课程简介" prop="courseprofile">
                    <el-input type="textarea" v-model="form4courseevaluation.courseprofile" :maxlength="120" placeholder="请输入课程简介"></el-input>
                </el-form-item>

            </el-form>
            <div class="demo-drawer__footer">
                <el-button @click="cancelForm">取 消</el-button>
                <el-button type="primary" @click="onSubmit4courseEvluation('form4courseevaluation')" :loading="loading">{{ loading ? '提交中 ...' : '确 定' }}</el-button>
            </div>
        </div>
    </el-drawer>
</div>
</template>

<script>
import AddOrUpdate from "./course-add-or-update";
import courseMaterial from "./course-material";
import coursePaiKe from "./course-paike";
import courseMaterialExpand from "./course-materialExpand";
import {
    getLoginToken
} from "../../../utils";
export default {
    data() {
        return {
            materials: {},
            courseId: "",
            materialVisible: false,
            drawerBycourseEvluation: false,
            drawerVisible: false,
            dataForm: {
                courseName: '',
                itemId: '',
                stageId: '',
            },
            form4courseevaluation: {
                course_id: '',
                course_name: '',
                id: '',
                knowledgepoints: '',
                stuff: '',
                tools: '',
                courseprofile: ''
            },
            kepcourseevaluation: {
                course_id: '',
                course_name: ''
            },
            dataList: [],
            pageIndex: 1,
            pageSize: 10,
            totalPage: 0,
            dataListLoading: false,
            addOrUpdateVisible: false,
            rules4courseevaluation: {
                knowledgepoints: [{
                    required: true,
                    message: '知识点不能为空',
                    trigger: 'blur'
                }],
                stuff: [{
                    required: true,
                    message: '教具及材料不能为空',
                    trigger: 'blur'
                }],
                tools: [{
                    required: true,
                    message: '工具不能为空',
                    trigger: 'blur'
                }],
                courseprofile: [{
                    required: true,
                    message: '课程简介不能为空',
                    trigger: 'blur'
                }]
            }
        };
    },
    computed: {
        onlineStatusParams() {
            return {
                type: "courseOnlineStatus"
            };
        },
        stageDictParams() {
            return {
                itemId: this.dataForm.itemId
            };
        },
        dictProps() {
            return {
                label: "value",
                value: "code"
            };
        },
        groupStageParams() {
            return {
                type: "StudentStage"
            };
        },
        userStageLevelParams() {
            return {
                type: this.dataForm.userStage
            };
        },
    },
    components: {
        AddOrUpdate,
        coursePaiKe,
        courseMaterial,
        courseMaterialExpand,
    },
    created() {
        this.getDataList();
        this.doSearch();
    },
    methods: {
        indexMethod(index) {
            return (this.pageIndex - 1) * this.pageSize + index + 1;
        },
        excel() {
            let url = this.$http.adornUrl("/course/course/excel")
            let param = "?token=" + getLoginToken()
            param += "&courseName=" + this.dataForm.courseName
            param += "&itemId=" + this.dataForm.itemId
            param += "&stageId=" + this.dataForm.stageId
            url = url + param;
            window.location.href = url;
        },
        // 获取数据列表
        getDataList() {
            this.dataListLoading = true;
            this.$http({
                url: this.$http.adornUrl("course/course/list"),
                method: "get",
                params: this.$http.adornParams({
                    page: this.pageIndex,
                    limit: this.pageSize,
                    ...this.dataForm,
                }),
            }).then(({
                data
            }) => {
                if (data && data.code === 0) {
                    this.dataList = data.page.list;
                    this.totalPage = data.page.totalCount;
                } else {
                    this.dataList = [];
                    this.totalPage = 0;
                }
                this.dataListLoading = false;
            });
        },
        // 每页数
        sizeChangeHandle(val) {
            this.pageSize = val;
            this.pageIndex = 1;
            this.getDataList();
        },
        // 当前页
        currentChangeHandle(val) {
            this.pageIndex = val;
            this.getDataList();
        },
        // 新增 / 修改
        addOrUpdateHandle(id) {
            this.addOrUpdateVisible = true;
            this.$nextTick(() => {
                this.$refs.addOrUpdate.init(id);
            });
        },
        // 更新物料
        updateMaterial(id) {
            this.materialVisible = true;
            this.$nextTick(() => {
                this.$refs.material.init(id);
            });
        },
        updateMaterialExpand(id) {
            this.$refs.courseMaterialExpand.open(id);
        },
        doSearch() {
            let that = this;
            document.onkeypress = function (e) {
                let keycode = document.all ? event.keyCode : e.which;
                if (keycode == 13) {
                    that.rgetDataList();
                }
            }
        },
        // 删除
        deleteHandle(row) {
            const {
                id,
                courseName
            } = row;
            this.$confirm(`确认删除${courseName}?`, "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                this.$http({
                    url: this.$http.adornUrl("/course/course/delete"),
                    method: "delete",
                    data: `${id}`,
                }).then(({
                    data
                }) => {
                    if (data && data.code === 0) {
                        this.$message({
                            message: "删除成功",
                            type: "success",
                        });
                        this.getDataList();
                    } else {
                        this.$message.error(data.msg);
                    }
                });
            });
        },
        // 排课
        paike(id) {
            this.courseId = id;
            this.drawerVisible = true;
        },
        handleSubmit({
            ids,
            params
        }) {
            this.$http({
                url: this.$http.adornUrl("course/record/save"),
                method: "post",
                data: this.$http.adornData({
                    studentIds: ids,
                    courseId: this.courseId,
                    endTime: params.endTime,
                    startTime: params.startTime,
                    userId: params.userId,
                }),
            }).then(({
                data
            }) => {
                if (data && data.code === 0) {
                    this.$message({
                        message: "排课成功",
                        type: "success",
                    });
                    this.drawerVisible = false;
                } else {
                    this.$message.error(data.msg);
                }
            });
        },
        onClickRow(row) {
            const i = this.dataList.findIndex((v) => v.id === row.id);
            this.dataList.splice(i, 1, {
                ...this.dataList[i],
                sortFlag: !this.dataList[i].sortFlag,
            });
        },
        onClickCourseNumRow(row) {
            const i = this.dataList.findIndex((v) => v.id === row.id);
            this.dataList.splice(i, 1, {
                ...this.dataList[i],
                courseNumFlag: !this.dataList[i].courseNumFlag,
            });
        },
        onSortBlur(row) {
            this.$http({
                url: this.$http.adornUrl(`course/course/update`),
                method: `put`,
                data: this.$http.adornData({
                    ...row,
                    sort: row.sort,
                }),
            }).then(({
                data
            }) => {
                if (data && data.code === 0) {
                    this.getDataList();
                    this.$message({
                        message: `更新成功`,
                        type: "success",
                    });
                } else {
                    this.$message.error(data.msg);
                }
            });
            this.onClickRow(row);
        },
        onCourseNumBlur(row) {
            if (row.courseNum < 0 || row.courseNum > 10) {
                this.$message({
                    message: `课时入参不正确！`,
                    type: "warning",
                });
                return;
            }
            this.$http({
                url: this.$http.adornUrl(`course/course/update`),
                method: `put`,
                data: this.$http.adornData({
                    ...row,
                    courseNum: row.courseNum,
                }),
            }).then(({
                data
            }) => {
                if (data && data.code === 0) {
                    this.getDataList();
                    this.$message({
                        message: `更新成功`,
                        type: "success",
                    });
                } else {
                    this.$message.error(data.msg);
                }
            });
            this.onClickCourseNumRow(row);
        },
        changeOnlineStatus(row) {
            this.$http({
                url: this.$http.adornUrl(`course/course/update`),
                method: `put`,
                data: this.$http.adornData({
                    ...row,
                    onlineStatus: row.onlineStatus,
                }),
            }).then(({
                data
            }) => {
                if (data && data.code === 0) {
                    this.getDataList();
                    this.$message({
                        message: `更新成功`,
                        type: "success",
                    });
                } else {
                    this.$message.error(data.msg);
                }
            });
        },
        //编辑课评模板
        editKePingModel(v) {
            this.form4courseevaluation = {}
            this.drawerBycourseEvluation = true
            if (v.id) {
                this.$http({
                    url: this.$http.adornUrl(`/course/course/GetKepingModel/${v.id}`),
                    method: "get",
                    params: this.$http.adornParams(),
                }).then(({
                    data
                }) => {
                    if (data.kepingModel) {
                        this.form4courseevaluation = data.kepingModel
                    } else {
                        this.kepcourseevaluation.course_id = v.id
                        this.kepcourseevaluation.course_name = v.courseName
                    }
                });
            }
        },
        onSubmit4courseEvluation(v) {
            this.form4courseevaluation.course_id=this.kepcourseevaluation.course_id
            this.form4courseevaluation.course_name=this.kepcourseevaluation.course_name
            if (v) {
                this.$refs[v].validate((valid) => {
                    if (valid) {
                        this.$http({
                            url: this.$http.adornUrl(`course/course/updateKepingModel`),
                            method: `put`,
                            data: this.form4courseevaluation,
                        }).then(({
                            data
                        }) => {
                            if (data && data.code === 0) {
                                this.cancelForm();
                                this.$message({
                                    message: `更新成功`,
                                    type: "success",
                                });
                            } else {
                                this.$message.error(data.msg);
                            }
                        });
                    } else {
                        return false;
                    }
                })
            } else {
                return false;

            }

        },
        cancelForm() {
            this.loading = false;
            this.drawerBycourseEvluation = false;
            this.form4courseevaluation = {}
        },
    },
};
</script>
